@if (item) {
    <div class="newvisitor-wrapper d-flex flex-column">
        <vn-header-bar [title]="title" [backButtonText]="item.messages?.Back || ''" (onBack)="back()" [showClose]="false" />
        <div class="newvisitor-content">
            <div class="newvisitor-content__text" [innerHtml]="item.text"></div>
            <div class="newvisitor-btn-container d-flex justify-content-center">
                <button ds-button kind="primary" variant="filled" size="large" class="w-50" (click)="register()">
                    {{ item.messages?.Register }}
                </button>
                <button ds-button kind="secondary" variant="outline" size="large" class="w-50" (click)="login()">{{ item.messages?.Login }}</button>
            </div>
        </div>
    </div>
}
